"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var StackToolbarImplementation_exports = {};
__export(StackToolbarImplementation_exports, {
  registerNativeStackToolbar: () => registerNativeStackToolbar,
  stackToolbarImplementation: () => stackToolbarImplementation
});
module.exports = __toCommonJS(StackToolbarImplementation_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_stack_toolbar_implementation = require("one/stack-toolbar-implementation");
var import_StackToolbar = require("./stack-toolbar/StackToolbar");
function mapToolbarChildren(children) {
  if (typeof children === "string" || typeof children === "number") return children;
  return import_react.Children.map(children, function(child) {
    if (!/* @__PURE__ */ (0, import_react.isValidElement)(child)) return child;
    var childType = child.type[import_stack_toolbar_implementation.STACK_TOOLBAR_CHILD];
    var NativeComponent;
    switch (childType) {
      case "button":
        NativeComponent = import_StackToolbar.StackToolbar.Button;
        break;
      case "menu":
        NativeComponent = import_StackToolbar.StackToolbar.Menu;
        break;
      case "menuAction":
        NativeComponent = import_StackToolbar.StackToolbar.MenuAction;
        break;
      case "spacer":
        NativeComponent = import_StackToolbar.StackToolbar.Spacer;
        break;
      case "searchBarSlot":
        NativeComponent = import_StackToolbar.StackToolbar.SearchBarSlot;
        break;
      case "view":
        NativeComponent = import_StackToolbar.StackToolbar.View;
        break;
      case "label":
        NativeComponent = import_StackToolbar.StackToolbar.Label;
        break;
      case "icon":
        NativeComponent = import_StackToolbar.StackToolbar.Icon;
        break;
      case "badge":
        NativeComponent = import_StackToolbar.StackToolbar.Badge;
        break;
    }
    if (!NativeComponent) return child;
    var props = child.props;
    return /* @__PURE__ */ (0, import_react.createElement)(NativeComponent, {
      ...props,
      key: child.key
    }, mapToolbarChildren(props.children));
  });
}
var stackToolbarImplementation = {
  appendPropsToOptions(options, props) {
    var _props_placement;
    if (((_props_placement = props.placement) !== null && _props_placement !== void 0 ? _props_placement : "bottom") === "bottom") return options;
    return (0, import_StackToolbar.appendStackToolbarPropsToOptions)(options, {
      ...props,
      children: mapToolbarChildren(props.children)
    });
  },
  render(props) {
    var _props_placement;
    if (((_props_placement = props.placement) !== null && _props_placement !== void 0 ? _props_placement : "bottom") !== "bottom") return null;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_StackToolbar.StackToolbar, {
      ...props,
      children: mapToolbarChildren(props.children)
    });
  }
};
function registerNativeStackToolbar() {
  (0, import_stack_toolbar_implementation.registerStackToolbarImplementation)(stackToolbarImplementation);
}
//# sourceMappingURL=StackToolbarImplementation.js.map
